(function(){
    if(typeof APPS === 'undefined'){ APPS = {}; }
    APPS.persons = {};
    
    /*================================================================================
		Router
	 ================================================================================*/
    var Router = Marionette.AppRouter.extend({
        appRoutes:{
             "person/:id" 	: "showPerson"
        }
    })
    
    /*================================================================================
		Api - called by the Router and through Radio events
	 ================================================================================*/
    var API = {
        showPerson:function(id){
            APPS.persons.show.show(id);
        }
    }
    
    /*================================================================================
		Radio - Event Handlers
	 ================================================================================*/
    Backbone.Radio.channel('persons').reply("person",function(id){
        Backbone.history.navigate('/person/'+id)
        if(typeof ga != "undefined"){ ga('set','page','/person/'+id); }
		if(typeof gtag != "undefined"){ gtag('set', { 'page_path': '/person'+id, 'page_location': window.location.origin+'/person'+id }); }
        API.showPerson(id);
    })
    
    
    APP.on("before:start",function(){
		new Router({
			controller: API
		})
	})
})();